<template>
  <div class="app">
    <div>
      <head1></head1>
    </div>
    <div class="banner">
      <div class="l-banner">
        <img src="@/assets/images/list_banner.jpg" alt="" width="100%" />
      </div>
      <div class="banner-title">
        <h1>信息公开</h1>
        <div class="banner_title_line"></div>
      </div>
    </div>
    <div class="bread-nav">
      <span>您的位置：</span>
      <span @click="home()" class="nav-item">首页</span>
      <span class="possplit"></span>
      <span>信息公开</span>
      <!-- <span class="possplit" v-if="index1 == 1"></span>
      <span v-if="index1 == 1">党建工作</span> -->
    </div>
    <div class="mgb80">
      <div class="content-web">
        <div class="left_nav">
          <div class="left_nav_title">
            <h1>信息公开</h1>
            <div class="left_nav_line"></div>
          </div>
          <div class="col_menu_con">
            <div class="col_list">
              <el-menu default-active="2" @select="handleSelect1" class="el-menu-vertical-demo"
                background-color="#023A8F" text-color="#fff" active-text-color="#206BD1">
                <el-menu-item v-for="(item, index) in xxgkList" :key="index" :index="item.menuId.toString()"
                  @click="checkId(item)">
                  <span :class="index1 == item.menuId ? 'activeColor' : ''">{{
                    item.name
                  }}</span>
                </el-menu-item>
              </el-menu>
            </div>
          </div>
        </div>
        <div class="inner_content_right">
          <jtjj v-if="index1 == 7"></jtjj>
          <ldtd v-if="index1 == 8" :id="id"></ldtd>
          <ssqy v-if="index1 == 9"></ssqy>
          <gljg v-if="index1 == 21" :id="id"></gljg>
          <ywfy v-if="index1 == 22" :id="id"></ywfy>
          <djgz v-if="index1 == 69" :id="id"></djgz>
          <qyjygl v-if="index1 == 24" :id="id"></qyjygl>
          <zyrsbd v-if="index1 == 65" :id="id"></zyrsbd>
          <xcgl v-if="index1 == 26" :id="id"></xcgl>
          <szyd v-if="index1 == 27"></szyd>
          <zdgz v-if="index1 == 28"></zdgz>
          <shzr v-if="index1 == 68" :id="id"></shzr>
          <ysgk v-if="index1 == 30" :id="id"></ysgk>
          <qtxx v-if="index1 == 31" :id="id"></qtxx>
          <!-- <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage4"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="400"
            >
            </el-pagination>
          </div> -->
        </div>
      </div>
    </div>

    <div class="footer">
      <foot></foot>
    </div>
    <div class="footer-bottom">
      <bottom></bottom>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import jtjj from "./jtjj.vue";
import djgz from "./djgz.vue";
import gljg from "./gljg.vue";
import ldtd from "./ldtd.vue";
import qtxx from "./qtxx.vue";
import qyjygl from "./qyjygl.vue";
import shzr from "./shzr.vue";
import ssqy from "./ssqy.vue";
import szyd from "./szyd.vue";
import xcgl from "./xcgl.vue";
import ysgk from "./ysgk.vue";
import ywfy from "./ywfw.vue";
import zdgz from "./zdgz.vue";
import zyrsbd from "./zyrsbd.vue";
import foot from "../footer.vue";
import bottom from "../bottom.vue";
import head1 from "../head.vue";
export default {
  name: "App",
  components: {
    djgz,
    gljg,
    ldtd,
    qtxx,
    qyjygl,
    shzr,
    ssqy,
    szyd,
    xcgl,
    ysgk,
    ywfy,
    zdgz,
    zyrsbd,
    jtjj,
    head1,
    bottom,
    foot,
  },
  data() {
    return {
      id: "",
      images: [],
      index: "1",
      index1: "1",
      radio1: "overview",
      currentPage4: 4,
      xxgkList: [],
    };
  },
  watch: {
    $route: {
      handler: function (newValue) {
        this.index1 = newValue.query.index1;
      },
    },
    deep: true,
  },
  created() {
    this.index1 = this.$route.query.index1;
    this.getMenus();
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    home() {
      this.$router.push("/");
    },
    checkId(item) {
      this.id = item.id;
      console.log(item, 8888774);
    },
    handleSelect1(key) {
      // console.log(key,8888774);
      this.index1 = key;
    },
    jtjj() {
      this.$router.push("/147");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    getMenus() {
      axios.get("/jtg/home/menus").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        res.data.forEach((item) => {
          if (item.state !== 1) {
            return;
          }

          if (item.dictLabel == "信息公开" && item.name != "信息公开") {
            this.xxgkList.push(item);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss">
.banner {
  position: relative;
  width: 100%;
  height: 350px;
  z-index: 99;

  .l-banner {
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    text-align: center;
    margin: 0 auto;
    background-size: cover;
    width: 100%;
    overflow: hidden;
    ;

    img {
      height: 326%;
      position: relative;
      top: -393px;
    }
  }

  .banner-title {
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -600px;
    box-sizing: border-box;
    padding-left: 41px;
    padding-top: 25px;
    width: 1200px;
    height: 110px;
    background-color: rgba(255, 255, 255, 0.8);

    h1 {
      font-size: 28px;
      color: #333;
    }

    .banner_title_line {
      width: 108px;
      height: 3px;
      margin: 3px 0;
      background-color: #88cc2f;
    }
  }
}

.activeColor {
  color: #206bd1 !important;
}

.bread-nav {
  width: 1200px;
  margin: 25px auto 0 auto;
  font-size: 14px;
  color: #666;

  span {
    margin-right: 20px;
  }

  .nav-item {
    cursor: pointer;
  }

  .possplit {
    position: relative;
    top: 3px;
    display: inline-block;
    margin: 0 10px;
    width: 1px;
    height: 16px;
    background-color: #acacac;
    background-image: none;
    margin-right: 20px;
  }
}

.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;

  .content-web {
    .el-menu {
      background-color: #fff !important;
    }

    .el-menu-item {
      width: 220px !important;
      background-color: #fff !important;
      font-size: 16px !important;
      color: #666 !important;
      border-bottom: 1px solid #f3f3f3;
      // padding-top: 15px !important;
      // padding-bottom: 15px !important;
      // padding-left: 15px !important;
    }

    display: flex;
    width: 1200px;
    // min-width: 1200px;
    margin: 0 auto;

    .left_nav {
      margin-right: 20px;
      height: 100%;
      display: inline;
      float: left;
      width: 220px;
      background-color: #fff;

      .left_nav_title {
        box-sizing: border-box;
        padding: 23px 20px 18px 40px;
        background-color: #206bd1;

        h1 {
          font-size: 22px;
          color: #fff;
        }

        .left_nav_line {
          height: 1px;
          background-color: #fff;
          opacity: 0.2;
          margin-top: 8px;
          margin-bottom: 5px;
        }
      }

      .left_nav_list {
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 10px 20px 10px;

        .left_nav_item {
          box-sizing: border-box;
          padding-top: 15px;
          padding-bottom: 15px;
          padding-left: 15px;
          border-bottom: 1px solid #f3f3f3;
        }
      }

      .select1 {
        color: #206bd1;
      }

      .li1::before {
        position: relative;
        left: -8px;
        top: 4px;
        width: 4px;
        content: "";
        background-color: #206bd1;
        height: 21px;
        display: inline-block;
      }

      // .left_nav_item:hover {
      //   color: #206bd1;
      //   border-left: 1px solid red;
      // }
      // .select2::afte:hover {
      //   position: relative;
      //   left: -8px;
      //   top: 4px;
      //   width: 200px;
      //   content: "";
      //   background-color: #206bd1;
      //   height: 21px;
      //   display: inline-block;
      // }
    }

    .inner_content_right {
      .block {
        margin: 10px 0 20px 0;
        text-align: center;
      }

      // float: right;
      box-sizing: border-box;
      width: 960px;
      min-height: 600px;
      // margin-left: 20px;
      background-color: #fff;

      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }

      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;
        ;

        .head {
          // border-bottom: 1px #444 dashed;
          // height: 500px;
        }
      }

      .text {
        text-indent: 45px;
      }

      .ltd {
        float: right;
      }
    }
  }
}

.fwl {
  margin-left: 140px;
}

.jicon {
  background: url(@/assets/images/icon-ba.png) no-repeat center left;
  padding-left: 12px;
}

// ::v-deep .el-menu--popup {
//   display: flex;
//   flex-wrap: wrap;
//   width: 850px !important;
//   background-color: #2d68c1 !important;
// }
.footer-bottom {
  height: 50px;
  min-width: 1200px;
  background-color: #424242;
}

.footer-bottom-con {
  width: 1200px;
  height: 50px;
  margin-left: 464px;
}

.footer-bottom-con span {
  font-size: 14px;
  color: #fff;
  line-height: 50px;
  padding-right: 10px;
}

.footer-bottom-con span a {
  text-decoration: none;
  font-size: 14px;
  color: #fff;
  line-height: 50px;
  padding-right: 10px;
}
</style>
